import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.css";
import "./index.scss";

import App from "./App";
import { setupLanguage } from "./App.i18n";
import { AuthProvider } from "./auth";
import { GetVar } from "./helpers/GetQueryVariable";
import { ENVIRONMENT, PROJECT_CODE } from "./shared/constants";
import { Tracing } from "./shared/Tracing";

function renderApplication() {
  const { language, locale, messages } = setupLanguage();
  const debugMode = GetVar("debug") === "true";
  const root = document.getElementById("root");
  const reactRoot = createRoot(root);

  reactRoot.render(
    <BrowserRouter>
      <AuthProvider>
        <IntlProvider locale={locale} messages={messages}>
          <App className="App" environment={ENVIRONMENT} language={language} locale={locale} debug={debugMode} />
        </IntlProvider>
      </AuthProvider>
    </BrowserRouter>,
  );
}

export const entryPoint = () => {
  try {
    console.debug("Starting", PROJECT_CODE, ENVIRONMENT);
    Tracing.init(PROJECT_CODE);
    renderApplication();
  } catch (error) {
    console.error("Application bootstrap error", error);
    Tracing.capture(error);
  }
};

entryPoint();
